import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { ThresholdSlider } from './ThresholdSlider'
import type { AvailableClass } from '@/types'

interface ClassConfidenceListProps {
  classes: AvailableClass[]                         // the active classes to tune
  baseDefault: number                               // model base confidence (fallback)
  onCommit: (classId: number, conf: number | null) => void
}

export function ClassConfidenceList({ classes, baseDefault, onCommit }: ClassConfidenceListProps) {
  const { t } = useTranslation('cameras')
  const [filter, setFilter] = useState('')
  const shown = classes.filter((c) => c.class_name.toLowerCase().includes(filter.toLowerCase()))
  return (
    <div className="space-y-2">
      <Input value={filter} onChange={(e) => setFilter(e.target.value)}
             placeholder={t('detection.classFilter')} className="h-9" />
      <div className="max-h-72 overflow-y-auto rounded-md border border-border/50 divide-y divide-border/50">
        {shown.map((c) => {
          const overridden = c.camera_override !== null && c.camera_override !== undefined
          const value = c.effective_confidence ?? baseDefault
          const inherited = c.global_confidence ?? baseDefault
          return (
            <div key={c.class_id} className="grid grid-cols-[7rem_1fr_4.75rem] items-center gap-2 px-3 py-2">
              <span className="truncate text-sm" title={c.class_name}>{c.class_name}</span>
              <ThresholdSlider value={value} ariaLabel={c.class_name}
                onCommit={(v) => onCommit(c.class_id, v)} />
              <button type="button" disabled={!overridden}
                onClick={() => onCommit(c.class_id, null)}
                className="whitespace-nowrap text-right text-xs text-primary underline disabled:opacity-40">
                {overridden ? t('detection.reset') : `${t('detection.inherits')} ${Math.round(inherited * 100)}%`}
              </button>
            </div>
          )
        })}
        {shown.length === 0 && (
          <p className="px-3 py-2 text-xs text-muted-foreground">{t('detection.noMatch')}</p>
        )}
      </div>
    </div>
  )
}
